<template>
  <div class="flex w-full flex-col md:flex-row md:gap-2">
    <a class="w-full" data-testid="gift-banner-link" target="_blank" :href="GIFT_LP_URL">
      <img alt="giftBanner" class="w-full" :src="giftBannerSrc" />
    </a>
    <a class="w-full" data-testid="gta-banner-link" target="_blank" :href="GTA_LP_URL">
      <img alt="gtaBanner" class="w-full" :src="gtaBannerSrc" />
    </a>
  </div>
</template>

<script lang="ts" setup>
// Import images
import GiftBannerPC from '@/wabunka-src/common/assets/img/banner/GiftBanner_PC.jpg';
import GiftBannerSP from '@/wabunka-src/common/assets/img/banner/GiftBanner_SP.jpg';
import GtaBannerPC from '@/wabunka-src/common/assets/img/banner/GtaBanner_PC.jpg';
import GtaBannerSP from '@/wabunka-src/common/assets/img/banner/GtaBanner_SP.jpg';
import { useIsSP } from '@/wabunka-src/common/composables';
import { GIFT_LP_URL } from '@/wabunka-src/constants/giftLp';
import { GTA_LP_URL } from '@/wabunka-src/constants/gtaLp';

const isSP = useIsSP();
const giftBannerSrc = computed(() => (isSP.value ? GiftBannerSP : GiftBannerPC));
const gtaBannerSrc = computed(() => (isSP.value ? GtaBannerSP : GtaBannerPC));
</script>
